import type { FC } from 'react';

import { observer } from 'mobx-react';

import { useStores } from '@/components/hooks';

import RecipientEmailRenderer from '@/components/MiniApps/RecipientPage/EmailRendering/RecipientEmailRenderer';
// eslint-disable-next-line max-len
import RecipientEmailErrorBoundary from '@/components/MiniApps/RecipientPage/EmailRendering/RecipientEmailErrorBoundary';
import styles from './EmailViewer.module.scss';

const EmailViewer: FC = observer(() => {
    const { recipientPageStore: { emailMessageStore } } = useStores();
    const {
        html, plainText, attachments, warning,
    } = emailMessageStore.letterContent;

    return (
        <div className={styles.container}>
            {warning && <p role="status" className={styles.warning}>{warning}</p>}
            <RecipientEmailErrorBoundary key={emailMessageStore.messageId || ''} plainText={plainText}>
                <RecipientEmailRenderer html={html} plainText={plainText} attachments={attachments} />
            </RecipientEmailErrorBoundary>
        </div>
    );
});

export default EmailViewer;
